import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="donation-amounts"
// Manages add/remove of suggested donation amount blocks in the organizer ticket form.
export default class extends Controller {
  static targets = ["list", "template", "addButton", "block"]

  add(event) {
    event.preventDefault()
    const clone = this.templateTarget.content.cloneNode(true)
    const input = clone.querySelector('input[name*="suggested_donation_amounts_dollars"]')
    if (input) input.value = ""
    this.listTarget.insertBefore(clone, this.addButtonTarget)
  }

  remove(event) {
    event.preventDefault()
    const block = event.currentTarget.closest("[data-donation-amounts-target='block']")
    if (!block) return
    if (this.blockTargets.length <= 1) return
    block.remove()
  }
}

